const deliveryChargeAreaControlGetters = {
    getterAreaNameSearchValue: ({ searchValue }) => searchValue.areaName,
    getterDongNameSearchValue: ({ searchValue }) => searchValue.dongName,
    getterEupMyeonDongBoundaryVisibleKeyList: ({ eupMyeonDongBoundaryInfo, }) => Object.keys(eupMyeonDongBoundaryInfo.visibleList),
    getterEupMyeonDongBoundaryVisibleList: ({ eupMyeonDongBoundaryInfo, }) => Object.values(eupMyeonDongBoundaryInfo.visibleList),
    getterEupMyeonDongBoundaryVisibleInfo: ({ eupMyeonDongBoundaryInfo, }) => eupMyeonDongBoundaryInfo.visibleList,
    getterEupMyeonDongBoundaryCurrentInfoList: ({ eupMyeonDongBoundaryInfo, }) => Object.values(eupMyeonDongBoundaryInfo.currentInfo),
    getterEupMyeonDongBoundaryCurrentInfo: ({ eupMyeonDongBoundaryInfo, }) => eupMyeonDongBoundaryInfo.currentInfo,
    getterRegisteredAreaList2: ({ registeredAreaList }) => registeredAreaList,
    getterRegisteredAreaList: ({ registeredAreaList, searchValue }, getters) => {
        const result = registeredAreaList.map((item) => ({
            ...item,
            isSelectable: !getters.getterIsCreateAreaMode,
        }));
        if (!searchValue.areaName) {
            return result;
        }
        return result.filter(({ areaName }) => areaName.includes(searchValue.areaName));
    },
    getterRegisteredAreaListLength: (state, getters) => getters.getterRegisteredAreaList.length,
    getterCheckedAreaList2: ({ checkedAreaList2 }) => checkedAreaList2,
    /**
     * 구역아이디로 구역의 데이터 조회
     * @param param0
     * @returns
     */
    getterFindItem: ({ registeredAreaList }) => (_areaId) => registeredAreaList.find(({ areaId }) => _areaId === areaId),
    getterCheckedAreaKeyList: ({ checkedAreaList2 }) => checkedAreaList2,
    getterCheckedAreaListLength: ({ checkedAreaList2 }) => checkedAreaList2.length,
    getterSelectedAreaName: ({ selectedArea }) => selectedArea.areaName,
    getterSelectedAreaId: ({ selectedArea }) => selectedArea.areaId,
    getterIsCreateAreaMode: ({ isCreateAreaMode }) => isCreateAreaMode,
    getterCurrentPolygonCoordinateList: ({ currentPolygon }) => currentPolygon.coordinateList,
    getterCurrentPolygonNeedResetList: ({ currentPolygon }) => currentPolygon.needResetList,
};
export default deliveryChargeAreaControlGetters;
